import { LinkRenderer } from "@/components/AppGrid/customCells/LinkRenderer";
import { NameRenderer } from "@/components/AppGrid/customCells/NameRenderer";
import { TagRenderer } from "@/components/AppGrid/customCells/TagInput";
import { ContactRecord } from "@/models/contact";
import { getDefaultContactDirectoryEntity } from "@/models/contactDirectory";
import { Route } from "@/paths";
import { ColDef } from "@ag-grid-community/core";
import { Timestamp } from "firebase/firestore";
import { getDefaultStore } from "jotai";
import { generatePath } from "react-router-dom";
import { ActionRenderer } from "./Main/ActionRenderer";
import { JobTitleTagEditor } from "./Main/JobTitleTagEditor";

export const defaultColDef: ColDef = {
  editable: true,
  suppressHeaderFilterButton: true,
  sortingOrder: ["asc", "desc"],
} as const;

const getContactDirectoryjobTitleTags = () => {
  const entity = getDefaultContactDirectoryEntity();
  const atom = entity.getObserveEntityRecordAtom();
  return getDefaultStore().get(atom)?.data?.jobTitleTags || [];
};

export const colDefs: (ColDef & { field: keyof ContactRecord })[] = [
  {
    field: "name",
    minWidth: 255,
    cellRenderer: NameRenderer,
    cellRendererParams: {
      resourceName: "contact",
      generatePath: (id: string) =>
        generatePath(Route.Contact, {
          contactId: id,
        }),
    },
  },
  {
    field: "createdAt",
    editable: false,
    headerName: "Created",
    cellDataType: "date",
    valueSetter: (params) => {
      params.data.createdAt = Timestamp.fromDate(new Date(params.newValue));
      return true;
    },
    valueGetter: (params) => params?.data?.createdAt?.toDate(),
    minWidth: 118,
    maxWidth: 118,
  },
  { field: "email" },
  {
    field: "phone",
  },
  { field: "firm", headerName: "Firm / Organization" },
  {
    headerName: "Role",
    field: "jobTitleIds",
    filter: true,

    cellEditor: JobTitleTagEditor,
    cellDataType: "object",
    cellEditorPopup: true,
    cellRenderer: TagRenderer,
    cellRendererParams: {
      getTagOptions: getContactDirectoryjobTitleTags,
    },
  },
  {
    field: "website",
    cellRenderer: LinkRenderer,
  },
  { field: "location" },
  { field: "remarks" },
  {
    field: "updatedAt",
    headerName: "Last Updated",
    sort: "desc",
    cellDataType: "date",
    valueSetter: (params) => {
      params.data.updatedAt = Timestamp.fromDate(new Date(params.newValue));
      return true;
    },
    valueGetter: (params) => params?.data?.updatedAt?.toDate(),
    //editable: false,
    minWidth: 118,
    maxWidth: 118,
    editable: false,
  },
  {
    field: "actions" as unknown as keyof ContactRecord,
    editable: false,
    filter: false,
    sortable: false,
    cellRenderer: ActionRenderer,
  },
] as const;
